import { cssVars } from '@/app/styles';
import { Charts } from '@/chart/chart';
import { LineChartOptions } from '@/chart/chart-options';
import { DEFAULT_CHART_BASE_TYPE } from '@/chart/components/all-charts-styles';
import { DisplayMinMaxValuePlugin } from '@/chart/plugins/display-min-max-value-plugin';
import { datasetTypes } from '@/constants';
import {
  MultiValueDataBuilder,
  constructDatasets,
} from '@/utils/chart-data-builder';
import { numberToPercent } from '@/utils/string-utils';

export class TOTDataBuilder extends MultiValueDataBuilder {
  constructor(
    data,
    chartMode = null,
    dataType = 'transientOccupancyTax',
    extractionType = 'value'
  ) {
    super(data, dataType, extractionType);
    this.chartMode = chartMode;
    this.datasetConfigurations = TOTDataBuilder.configurations;
  }

  static get configurations() {
    return [
      {
        fill: '+1',
        pointRadius: 0,
        borderWidth: 2,
        borderColor: '#00bfa5',
        backgroundColor: 'rgba(224, 242, 241, 0.5)',
      },
      {
        fill: '+1',
        borderWidth: 2,
        pointRadius: 0,
        borderColor: '#fdb147',
        backgroundColor: '#fdb147',
      },
    ];
  }

  /**
   * This method extracts the data needed for the TOT chart from the kpi data points.
   * It overrides `extractMultiSets` from `MultiValueDataBuilder`
   *
   * @param {[*]} param.dataPoints kpi datapoints.. performance indicators for each month
   */
  extractMultiSets({ dataPoints }) {
    const estimateTotValues = dataPoints.map(
      (point) => point?.estimateTot?.value
    );
    const actualTotValues = this.builderOptions?.enableActualTOTValues
      ? dataPoints.map((point) => point?.actualTot?.value)
      : [];

    const datasets = [estimateTotValues, actualTotValues];
    const checkedData = this.checkPercentageOverflow(datasets);
    return checkedData;
  }

  get retrieveDatasets() {
    return constructDatasets(
      this.labels,
      this.data,
      'line',
      this.datasetConfigurations
    );
  }
}

class TransientOccupancyTaxChart extends Charts {
  static pluginParams = {
    pluginTextColor: cssVars.chartColors.TOT,
    pluginFormatter: numberToPercent,
    pluginAlignment: 'top',
  };

  static tooltipParams = {
    unit: '$',
  };

  static getParams() {
    return {
      pluginParams: this.pluginParams,
      tooltipParams: this.tooltipParams,
    };
  }

  static getOptions(props) {
    return {
      ...this.getParams(),
      ...props,
    };
  }

  constructor(props) {
    super({
      DataBuilder: TOTDataBuilder,
      chartProps: props,
      name: datasetTypes.TRANSIENT_OCCUPANCY_TAX,
      options: new LineChartOptions(
        TransientOccupancyTaxChart.getOptions(props)
      ).chartOptions,
      baseType: DEFAULT_CHART_BASE_TYPE,
      plugins: [DisplayMinMaxValuePlugin()],
    });
  }
}

const chart = (props) => new TransientOccupancyTaxChart(props).chart;

export default chart;
